import * as api    from './api.js'

export function onMount(url) {
    return api
        .get(url)
        .then(res => {
            if(res.status === 200) return res.json() 
            else throw 'Erro carregando dados'
        })
}

export function onRemove(url) {
    return api
        .exec(url, 'DELETE')
        .then(res => {
            if(res.status !== 200) {
                throw 'Erro ao remover'
            }
        })
}

export function onUpdate(url, method, payload) {
    return api
        .exec(url, method, payload)
        .then(res => {
            if(res.status === 200) 
                return res.json()
                    .then(json => Promise.resolve(json))
                    .catch(()  => Promise.resolve(null))
            else
                throw 'Erro ao salvar'
        })
}